// Number inputs show "1,234,567" but keep the raw "1234567" in state, so
// existing Number()/validation code stays unchanged.

export const parseNumberInput = (text) => {
  const cleaned = String(text ?? "").replace(/[^\d.]/g, "")
  const [int, ...frac] = cleaned.split(".")
  const intPart = int.replace(/^0+(?=\d)/, "")
  return frac.length ? `${intPart}.${frac.join("")}` : intPart
}

export const formatNumberInput = (value) => {
  if (value == null || value === "") return ""
  const [int, frac] = String(value).split(".")
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return frac === undefined ? grouped : `${grouped}.${frac}`
}
